import React from "react";

function LivePage() {
  return (
    <div className="text-center mt-5">
      <h1>🎥 Page Live</h1>
      <p>Ici tu pourras démarrer un live (stream en direct).</p>
    </div>
  );
}

export default LivePage;
